import React from "react";
import { useFormik, FormikProvider } from "formik";
import { Button } from "@design-system/Button/Button";
import { PlainModal, StandardModalHeader } from "@design-system/Modal/Modal";
import { createFormikFields } from "@components/forms/fields/createFormikFields";
import { HStack } from "@design-system/HStack/HStack";
import { VStack } from "@design-system/VStack/VStack";

interface LinkInputValues {
    url: string;
}

const fields = createFormikFields<LinkInputValues>();

interface LinkInputModalProps {
    show: boolean;
    onHide: () => void;
    onSubmit: (url: string) => void;
}

export const LinkInputModal: React.FC<LinkInputModalProps> = ({
    show,
    onHide,
    onSubmit,
}) => {
    const onClose = () => {
        formik.resetForm();
        onHide();
    };

    const formik = useFormik<LinkInputValues>({
        initialValues: { url: "" },
        onSubmit: (values) => {
            if (values.url.trim()) {
                onSubmit(values.url.trim());
            }
            onClose();
        },
    });

    return (
        <PlainModal show={show} onHide={onClose}>
            <StandardModalHeader>Add Link</StandardModalHeader>
            <FormikProvider value={formik}>
                <form onSubmit={formik.handleSubmit}>
                    <VStack gap={24}>
                        <fields.Text
                            name="url"
                            label="URL"
                            placeholder="https://example.com"
                            size="xl"
                        />
                        <HStack as="footer" justify="end" gap={12}>
                            <Button
                                type="button"
                                variant="secondary"
                                size="md"
                                onClick={onClose}
                            >
                                Cancel
                            </Button>
                            <Button type="submit" variant="primary" size="md">
                                Add
                            </Button>
                        </HStack>
                    </VStack>
                </form>
            </FormikProvider>
        </PlainModal>
    );
};
